import { cn } from "@rarible_int/anaconda_ui_components"
import type { ReactNode } from "react"

function ProgressDots({ dots }: { dots: string }) {
  const visibleDots = dots.length

  return (
    <span
      aria-hidden="true"
      className="ml-0 inline-grid w-[0.78em] grid-cols-3 align-baseline"
    >
      {[0, 1, 2].map((index) => (
        <span
          key={index}
          className={cn(
            "text-center",
            index < visibleDots ? "opacity-100" : "opacity-0",
          )}
        >
          .
        </span>
      ))}
    </span>
  )
}

export function GachaProgressLabel({
  label,
  dots,
}: {
  label: ReactNode
  dots?: string
}) {
  return (
    <span className="inline-flex items-baseline gap-0">
      <span>{label}</span>
      {dots ? <ProgressDots dots={dots} /> : null}
    </span>
  )
}
